// @flow

import type { PaymentSpecGenerator } from '@tectonics/prs/payment-spec/generator';
import { shouldHideCustomerEmailField, isLocalPayment, needsCaptcha } from '@tectonics/prs/incoming-payment';

const paymentSpecGenerator: PaymentSpecGenerator = {

  features: ({ incomingPayment }) => {
    const features = [
      { name: 'display_merchant_logo', traits: [] },
      { name: 'display_receipt_original_amount', traits: [] },
      ...(isLocalPayment(incomingPayment) ? [] : [{ name: 'display_receipt_fx_rate', traits: [] }]),
      { name: 'display_receipt_final_amount', traits: [] },
    ];

    if (incomingPayment.status === 'OP') {
      return [
        ...features,
        ...(shouldHideCustomerEmailField(incomingPayment) ? [] : [{ name: 'field_customer_email', traits: [] }]),
        { name: 'field_customer_name', traits: [] },
        { name: 'field_accept_terms', traits: [] },
        { name: 'field_bolivian_phone_number', traits: [] },
        ...(needsCaptcha(incomingPayment) ? [{ name: 'field_captcha_token', traits: [] }] : []),
        { name: 'display_back_button', traits: [] },
      ];
    }

    return features;
  },

  cash: ({ incomingPayment }) => {
    switch (incomingPayment.status) {
      case 'OP':
        return [
          { name: 'display_pagosnet_instructions', traits: [] },
        ];
      case 'PE':
        return [
          { name: 'display_pagosnet_total_value', traits: [] },
          { name: 'display_pagosnet_due_date', traits: [] },
          { name: 'display_pagosnet_success_message', traits: [] },
          { name: 'display_pagosnet_number', traits: [] },
          { name: 'action_pagosnet_save_pdf', traits: [] },
          { name: 'action_pagosnet_print_instructions' },
          { name: 'display_pagosnet_tip', traits: [] },
          { name: 'display_pagosnet_merchant_info', traits: [] },
          { name: 'display_pagosnet_email_warning', traits: [] },
          { name: 'display_pagosnet_locations', traits: [] },
        ];
      default:
        return [];
    }
  },
};

export default paymentSpecGenerator;
